import React, { useState, useEffect, useMemo, useRef } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaList, FaUpload, FaCalendarAlt, FaPen, FaPlus, FaSearch, FaThumbsUp, FaUsers, FaTable, FaQrcode, FaQuestion, FaFileAlt, FaUserTie, FaEllipsisV, FaPlane, FaBan, FaDownload, FaLink, FaFilter, FaTimes, FaExchangeAlt, FaFileInvoiceDollar, FaHeadset } from 'react-icons/fa';
import { RiMailSendLine } from 'react-icons/ri';
import { BsCardChecklist } from 'react-icons/bs';
import { GrMail } from "react-icons/gr";
import { ImCancelCircle } from 'react-icons/im';
import { GiOpenChest } from 'react-icons/gi';
import Alert from '../../components/Alert';
import api from '../../services/api';
import moment from 'moment';
import { dataMysql, moeda } from '../../util/util';
import { PERFIS_RSVP, PERFIS_EVENTOS, PERFIS_AEREO } from '../../util/malhaAereo';
import Select from 'react-select';
import { useLocation, Link } from 'react-router-dom';
import ReactSelect from '../../components/ReactSelect';
import { toast } from 'react-toastify';
import ContratacaoForm from '../../components/ContratacaoForm';
import FreelancerForm from '../../components/FreelancerForm';
import EmissaoAereoForm from '../../components/EmissaoAereoForm';
import { useAtendimentoAereo } from '../../components/AtendimentoAereo';
import RecusarEvento from '../../components/RecusarEvento';
import FechamentoEventoModal, { DEPARTAMENTOS_FECHAMENTO, departamentoDoPerfil } from '../../components/FechamentoEventoModal';
import TabelaLoading from '../../components/TabelaLoading';
import TabelaVazia from '../../components/TabelaVazia';
import { NumericFormat } from 'react-number-format';
import { PERFIS_ENVIO_MASSA } from '../../components/CartaFilaStatus';
import { usePermissoes } from '../../context/PermissoesContext';
import { ehRestrita } from '../../util/acessoPermissao';
import '../../css/financeiro-parcela-pagar.css';

export default function PainelEvento() {
    const RESPONSAVEL_SEM_RESPONSAVEL_OPTION = { value: '', label: 'Sem Responsável' };
    const PAGE_SIZE_DEFAULT = 20;
    const situacoesPorAba = {
        abertos: ['ativo'],
        fechados: ['fechado'],
        cancelados: ['cancelado'],
        pendentes: ['pendente'],
        // Os pendentes que o departamento de quem está logado já fechou.
        fechadosDepartamento: ['pendente'],
    };
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem("empresa");
    const perfilOriginal = localStorage.getItem("perfil");
    const perfil = perfilOriginal === 'suplier' ? 'diretor' : perfilOriginal;
    const departamentoUsuario = departamentoDoPerfil(perfil);
    const permissoes = usePermissoes();
    const idUsuario = localStorage.getItem("idUsuario");
    const perfisComAcessoFreelancer = ['admin', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'evento', 'gerentersvp', 'coordenadorrsvp', 'backofficeinterno'];
    const perfisContratacaoFreelancerEditaveis = ['admin', 'diretor', 'backofficeinterno'];
    const perfisContratacaoFreelancerVisiveis = [...perfisContratacaoFreelancerEditaveis, 'gerenteevento', 'evento', 'gerentefinanceiro', 'financeiro'];
    const [filtro, setFiltro] = useState({});
    const [dados, setDados] = useState({});
    const [eventos, setEventos] = useState([]);
    const [tableSelect, setTableSelect] = useState({});
    const [showQAModal, setShowQAModal] = useState(false);
    const [showOrdemServicoModal, setShowOrdemServicoModal] = useState(false);
    const [showFreelancerModal, setShowFreelancerModal] = useState(false);
    const [showContratacaoFreelancerModal, setShowContratacaoFreelancerModal] = useState(false);
    const [showSatisfacaoModal, setShowSatisfacaoModal] = useState(false);
    const [resumoSatisfacao, setResumoSatisfacao] = useState(null);
    const [carregandoResumoSatisfacao, setCarregandoResumoSatisfacao] = useState(false);
    const [enviandoEmailSatisfacao, setEnviandoEmailSatisfacao] = useState(false);
    const URL_PESQUISA_CLIENTE = process.env.REACT_APP_CLIENTE_URL || 'https://cliente.infoaccess-mkt.com.br';
    const [showEmissaoAereoModal, setShowEmissaoAereoModal] = useState(false);
    const [showRecusarEventoModal, setShowRecusarEventoModal] = useState(false);
    const [showParcelasModal, setShowParcelasModal] = useState(false);
    const [parcelas, setParcelas] = useState([]);
    const [carregandoParcelas, setCarregandoParcelas] = useState(false);
    const [selectedEvento, setSelectedEvento] = useState(null);
    const [showActionsModal, setShowActionsModal] = useState(false);
    const [actionsModalData, setActionsModalData] = useState({ evento: null, actions: [] });
    // O evento cujo atendimento do Aéreo está aberto, pela ação "Atendimento" do menu da linha.
    const [eventoAtendimento, setEventoAtendimento] = useState(null);
    const atendimento = useAtendimentoAereo(eventoAtendimento);
    // O evento com o modal do Fechamento aberto, pela ação "Fechamento" do menu da linha.
    const [fechamentoDe, setFechamentoDe] = useState(null);
    const [abaAtiva, setAbaAtiva] = useState('abertos'); // 'abertos' ou 'fechados_cancelados'
    const [inicializado, setInicializado] = useState(false);
    const buscarIdRef = useRef(0);
    const [mostrarFiltros, setMostrarFiltros] = useState(false);
    const [carregandoFiltros, setCarregandoFiltros] = useState(false);
    const [opcoesCliente, setOpcoesCliente] = useState([]);
    const [opcoesResponsavel, setOpcoesResponsavel] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: PAGE_SIZE_DEFAULT,
        total: 0,
    });
    const [ordenacao, setOrdenacao] = useState(null);
    const [resumoSituacao, setResumoSituacao] = useState({
        abertos: 0,
        fechados: 0,
        cancelados: 0,
        pendentes: 0,
    });
    const params = new URLSearchParams(window.location.search);
    const idEvento = params.get('idEvento');
    const responsavelId = params.get('responsavel');
    const responsavelNome = params.get('nomeResponsavel');
    const responsavelAgenciaId = params.get('responsavelagencia');
    const dataInicial = params.get('dataInicial');
    const dataFinal = params.get('dataFinal');
    const situacao = params.get('situacao');
    const cacheNamespace = `painelEvento:${empresa || 'sem-empresa'}:${perfil || 'sem-perfil'}:${idUsuario || 'sem-usuario'}`;
    const situacoesAbaAtiva = situacoesPorAba[abaAtiva] ?? situacoesPorAba.abertos;

    const normalizarTexto = (valor) => (valor ?? "").toString().toLowerCase();

    const formatarBadgeTotal = (total) => total > 99 ? '99+' : total;

    const totalResumoAba = (aba) => resumoSituacao[aba] ?? 0;

    const buscarResumoSituacao = (paramsBusca) => {
        const paramsResumo = { ...paramsBusca };
        delete paramsResumo.situacao;
        delete paramsResumo.page;
        delete paramsResumo.pageSize;
        // Os contadores contam todas as abas: o filtro da aba do departamento sai, e o back devolve à parte
        // quantos pendentes o departamento já fechou.
        delete paramsResumo.departamentoFechado;
        delete paramsResumo.departamentoAberto;
        if (departamentoUsuario) {
            paramsResumo.departamentoFechamento = departamentoUsuario;
        }

        api({
            method: 'get',
            action: '/evento/resumoSituacao',
            token: token,
            params: paramsResumo
        })
            .then((response) => {
                const resumoPorAba = {
                    abertos: 0,
                    fechados: 0,
                    cancelados: 0,
                    pendentes: 0,
                };
                const situacaoParaAba = {
                    ativo: 'abertos',
                    fechado: 'fechados',
                    cancelado: 'cancelados',
                    pendente: 'pendentes',
                };

                (response.data.data || []).forEach((item) => {
                    const aba = situacaoParaAba[item.situacao];
                    if (aba) {
                        resumoPorAba[aba] = item.total ?? 0;
                    }
                });

                // Os pendentes que o departamento já fechou saem da aba Pendentes e vão para a dele.
                const fechadosPeloDepartamento = response.data.pendentesFechadosPeloDepartamento ?? 0;
                resumoPorAba.fechadosDepartamento = fechadosPeloDepartamento;
                resumoPorAba.pendentes = Math.max(0, resumoPorAba.pendentes - fechadosPeloDepartamento);

                setResumoSituacao(resumoPorAba);
            })
            .catch(() => {
                setResumoSituacao({
                    abertos: 0,
                    fechados: 0,
                    cancelados: 0,
                    pendentes: 0,
                });
            });
    };

    const montarLabelParticipante = (registro) => {
        return registro.codigo +
            ' - ' + registro.nome +
            (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
            (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
            (registro.cpf ? ' (' + registro.cpf + ')' : '') +
            (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
    };

    const montarOpcoesParticipante = (registros) => {
        return registros.map((registro) => ({
            value: registro.id,
            label: montarLabelParticipante(registro),
        }));
    };

    const lerCacheFiltros = (tipo) => {
        try {
            const raw = sessionStorage.getItem(`${cacheNamespace}:${tipo}`);
            if (!raw) {
                return null;
            }

            const parsed = JSON.parse(raw);
            if (!parsed?.expiresAt || parsed.expiresAt < Date.now() || !Array.isArray(parsed.options)) {
                sessionStorage.removeItem(`${cacheNamespace}:${tipo}`);
                return null;
            }

            return parsed.options;
        } catch (error) {
            sessionStorage.removeItem(`${cacheNamespace}:${tipo}`);
            return null;
        }
    };

    const salvarCacheFiltros = (tipo, options) => {
        sessionStorage.setItem(`${cacheNamespace}:${tipo}`, JSON.stringify({
            expiresAt: Date.now() + (15 * 60 * 1000),
            options,
        }));
    };

    const buscarOpcoesParticipante = ({ tipoCadastro }) => {
        return api({
            method: 'get',
            action: '/participante',
            token: token,
            params: {
                tipoCadastro,
                situacaoRegistro: "ativo",
            }
        }).then((response) => montarOpcoesParticipante(response.data.data));
    };

    const carregarFiltrosAvancados = async () => {
        if (carregandoFiltros) {
            return;
        }

        const cacheCliente = lerCacheFiltros('cliente');
        const cacheResponsavel = lerCacheFiltros('responsavel');

        if (cacheCliente && cacheResponsavel) {
            setOpcoesCliente(cacheCliente);
            setOpcoesResponsavel(cacheResponsavel);
            return;
        }

        setCarregandoFiltros(true);
        try {
            const [clientes, responsaveis] = await Promise.all([
                cacheCliente ? Promise.resolve(cacheCliente) : buscarOpcoesParticipante({ tipoCadastro: 'cliente' }),
                cacheResponsavel ? Promise.resolve(cacheResponsavel) : buscarOpcoesParticipante({ tipoCadastro: 'pessoa' }),
            ]);

            setOpcoesCliente(clientes);
            setOpcoesResponsavel(responsaveis);

            if (!cacheCliente) {
                salvarCacheFiltros('cliente', clientes);
            }
            if (!cacheResponsavel) {
                salvarCacheFiltros('responsavel', responsaveis);
            }
        } catch (error) {
            toast.error('Erro ao carregar filtros avançados.');
        } finally {
            setCarregandoFiltros(false);
        }
    };

    const filtrarOpcoesLocais = (options, input) => {
        const termo = normalizarTexto(input).trim();
        if (termo === "") {
            return options;
        }

        return options.filter((option) => normalizarTexto(option.label).includes(termo));
    };

    const opcoesResponsavelComItemFixo = useMemo(() => {
        return [
            RESPONSAVEL_SEM_RESPONSAVEL_OPTION,
            ...opcoesResponsavel.filter((option) => option.value !== RESPONSAVEL_SEM_RESPONSAVEL_OPTION.value),
        ];
    }, [opcoesResponsavel]);

    const valorResponsavelFiltro = useMemo(() => {
        if (filtro.qualquerResponsavel === '') {
            return RESPONSAVEL_SEM_RESPONSAVEL_OPTION;
        }

        if (filtro.qualquerResponsavel) {
            return { value: filtro.qualquerResponsavel, label: filtro.nomeResponsavel };
        }

        return null;
    }, [filtro.nomeResponsavel, filtro.qualquerResponsavel]);

    const abrirFiltros = () => {
        setMostrarFiltros(true);
        carregarFiltrosAvancados();
    };

    const buscarParcelasEvento = (eventoId) => {
        setCarregandoParcelas(true);
        api({
            method: 'get',
            action: '/evento/parcelas/' + eventoId,
            token: token,
        })
            .then(response => {
                setParcelas(response.data.data || []);
                setCarregandoParcelas(false);
            })
            .catch(err => {
                toast.error('Erro ao carregar parcelas do evento');
                setCarregandoParcelas(false);
                setParcelas([]);
            });
    };

    const buscar = ({ page = pagination.page, pageSize = pagination.pageSize, resetPage = false, orderBy = ordenacao } = {}) => {
        // Validação de datas
        if (filtro.dataInicial && filtro.dataFinal && filtro.dataInicial > filtro.dataFinal) {
            toast.error('A data inicial não pode ser maior que a data final');
            return;
        }

        // Incrementa o ID da busca — respostas de buscas anteriores serão ignoradas
        const buscarId = ++buscarIdRef.current;

        if (resetPage) {
            setTableSelect({});
        }

        setFiltro(prevFiltro => ({ ...prevFiltro, buscando: true }));
        var quarterMap = [];
        if (filtro.quarter !== undefined)
            quarterMap = filtro.quarter.map((e) => { return e.value });
        const {
            nomeResponsavel: _nomeResponsavel,
            nomeCliente: _nomeCliente,
            buscando: _buscando,
            ...filtroBusca
        } = filtro;
        const paramsBusca = {
            ...filtroBusca,
            ...{ situacao: situacoesAbaAtiva },
            ...{ perfil: perfil },
            ...{ quarter: quarterMap },
            ...{ id: idEvento },
            ...{ page: page },
            ...{ pageSize: pageSize },
            ...(orderBy && { orderBy: JSON.stringify(orderBy) }),
            ...(filtro.dataInicial && { dataInicial: filtro.dataInicial }),
            ...(filtro.dataFinal && { dataFinal: filtro.dataFinal }),
            // Aba do departamento: só os pendentes que ele já fechou; na aba Pendentes, só os que ainda não.
            ...(departamentoUsuario && abaAtiva === 'fechadosDepartamento' && { departamentoFechado: departamentoUsuario }),
            ...(departamentoUsuario && abaAtiva === 'pendentes' && { departamentoAberto: departamentoUsuario })
        };
        buscarResumoSituacao(paramsBusca);

        const finalizarBusca = (response) => {
            if (buscarId !== buscarIdRef.current) return; // resposta de busca antiga, ignora
            const lista = response.data.data || [];
            const total = response.data.total ?? lista.length;
            const paginaAtual = response.data.page ?? page;
            const tamanhoPagina = response.data.pageSize ?? pageSize;

            setEventos(lista);
            setPagination({
                page: paginaAtual,
                pageSize: tamanhoPagina,
                total: total,
            });
            setFiltro(prevFiltro => ({ ...prevFiltro, buscando: false }));
        };

        api({
            method: 'get',
            action: '/evento/painelResumo',
            token: token,
            params: paramsBusca
        })
            .then(finalizarBusca)
            .catch(() => {
                if (buscarId !== buscarIdRef.current) return;
                api({
                    method: 'get',
                    action: '/evento',
                    token: token,
                    params: paramsBusca
                })
                    .then(finalizarBusca)
                    .catch(() => {
                        if (buscarId !== buscarIdRef.current) return;
                        setFiltro(prevFiltro => ({ ...prevFiltro, buscando: false }));
                        toast.error('Erro ao buscar eventos. Verifique sua conexão e tente novamente.');
                    });
            });
    };

    const ordenarTabela = (column, sortDirection) => {
        if (!column.sortField) {
            return;
        }

        const novaOrdenacao = { [column.sortField]: sortDirection };
        setOrdenacao(novaOrdenacao);
        buscar({ page: 1, resetPage: true, orderBy: novaOrdenacao });
    };

    const buscarParticipantePorId = async (id) => {
        try {
            const response = await api({
                method: 'get',
                action: '/participante/' + id,
                token: token,
            });
            return response.data.data;
        } catch (error) {
            console.error('Erro ao buscar participante:', error);
            return null;
        }
    };

    useEffect(() => { //onload
        //document.querySelector("#nome")?.focus(); //autofocus no nome

        const inicializarFiltros = async () => {
            // Se há parâmetros de responsável na URL, preencher o filtro automaticamente
            if (responsavelId && responsavelNome) {
                setFiltro(prevFiltro => ({
                    ...prevFiltro,
                    qualquerResponsavel: responsavelId,
                    nomeResponsavel: decodeURIComponent(responsavelNome)
                }));
            }

            // Se há apenas o ID do responsável agência, buscar o nome automaticamente
            if (responsavelAgenciaId && !responsavelId) {
                const participante = await buscarParticipantePorId(responsavelAgenciaId);
                if (participante) {
                    setFiltro(prevFiltro => ({
                        ...prevFiltro,
                        qualquerResponsavel: responsavelAgenciaId,
                        nomeResponsavel: participante.nome
                    }));
                }
            }

            // Se há parâmetros de data na URL, preencher o filtro automaticamente
            if (dataInicial) {
                setFiltro(prevFiltro => ({
                    ...prevFiltro,
                    dataInicial: dataInicial
                }));
            }

            if (dataFinal) {
                setFiltro(prevFiltro => ({
                    ...prevFiltro,
                    dataFinal: dataFinal
                }));
            }

            // Se há parâmetro de situação na URL, definir a aba ativa
            if (situacao) {
                if (situacao === 'ativo') {
                    setAbaAtiva('abertos');
                } else if (situacao === 'fechado') {
                    setAbaAtiva('fechados');
                } else if (situacao === 'cancelado') {
                    setAbaAtiva('cancelados');
                }
            }

            // Se há idEvento na URL ou não há parâmetros de responsável, fazer busca inicial
            if (idEvento || (!responsavelId && !responsavelAgenciaId)) {
                buscar({ page: 1, resetPage: true });
            }

            setInicializado(true);
        };

        inicializarFiltros();
    },
        // eslint-disable-next-line
        []);

    // Executar busca quando filtro for definido pelos parâmetros da URL
    useEffect(() => {
        if (inicializado && (
            idEvento ||
            (responsavelId && responsavelNome && filtro.qualquerResponsavel === responsavelId) ||
            (responsavelAgenciaId && filtro.qualquerResponsavel === responsavelAgenciaId) ||
            (dataInicial && filtro.dataInicial === dataInicial) ||
            (dataFinal && filtro.dataFinal === dataFinal) ||
            (situacao && (abaAtiva === 'abertos' || abaAtiva === 'fechados' || abaAtiva === 'cancelados'))
        )) {
            buscar({ page: 1, resetPage: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filtro.qualquerResponsavel, filtro.dataInicial, filtro.dataFinal, inicializado, abaAtiva, idEvento]);

    useEffect(() => {
        if (!inicializado) {
            return;
        }

        buscar({ page: 1, resetPage: true });
    }, [abaAtiva]);

    // Ao abrir o modal de Satisfação, buscar resumo (envio e respostas)
    useEffect(() => {
        if (!showSatisfacaoModal || !selectedEvento?.id) {
            setResumoSatisfacao(null);
            return;
        }
        setCarregandoResumoSatisfacao(true);
        api({
            method: 'get',
            action: '/eventoSatisfacaoPergunta/resumoSatisfacao/' + selectedEvento.id,
            token: token,
        })
            .then(res => {
                const data = res.data?.data ?? res.data;
                setResumoSatisfacao(data || null);
            })
            .catch(() => setResumoSatisfacao(null))
            .finally(() => setCarregandoResumoSatisfacao(false));
    }, [showSatisfacaoModal, selectedEvento?.id, token]);

    const dadosParaExibir = useMemo(() => (eventos || []), [eventos]);

    // Função para renderizar o dropdown de ações
    const renderActionDropdown = (row) => {
        let actions = [];

        // ========== EDIÇÃO/CADASTRO ==========
        // Alterar evento
        if (['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'evento', 'rsvp', 'gerentersvp', 'coordenadorrsvp', 'backoffice'].includes(perfil)) {
            actions.push({
                label: 'Alterar',
                icon: <FaPen size={16} />,
                to: "/cadastroEvento/" + row.id
            });
        }

        // Dados RSVP
        if (['admin', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'].includes(perfil)) {
            actions.push({
                label: 'Dados RSVP',
                icon: <FaPen size={16} />,
                to: "/cadastroEventoRsvp/" + row.id
            });
        }

        // Dados Iniciais RSVP
        if (['admin', 'gerenteevento', 'gerenteeventointernacional', 'evento', 'gerentersvp', 'coordenadorrsvp'].includes(perfil)) {
            actions.push({
                label: 'Dados Iniciais RSVP',
                icon: <FaPen size={16} />,
                to: "/eventoDadosIniciaisRsvp/" + row.id
            });
        }

        // ========== PARTICIPANTES ==========
        // Participantes
        if (['admin', 'gerenteprojeto', 'rsvp', 'operadorrsvp', 'gerentersvp', 'coordenadorrsvp', 'listarsvp'].includes(perfil)) {
            actions.push({
                label: 'Participantes',
                icon: <FaUsers size={16} />,
                to: "/eventoParticipante/" + row.id,
                badge: row.participantes ?? 0,
            });
        }

        // Importar Participantes
        if (['admin', 'gerenteprojeto', 'gerentersvp', 'coordenadorrsvp'].includes(perfil)) {
            actions.push({
                label: 'Importar Participantes',
                icon: <FaUpload size={16} />,
                to: "/eventoImportarParticipante/" + row.id
            });
        }

        // ========== GESTÃO DO EVENTO ==========
        // Checklist
        if (['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'gerentersvp', 'coordenadorrsvp'].includes(perfil)) {
            actions.push({
                label: 'Checklist',
                icon: <BsCardChecklist size={16} />,
                to: "/checklist?idEvento=" + row.id
            });
        }

        // Agenda
        if (['admin', 'gerenteprojeto', 'gerentefinanceiro', 'gerenteevento', 'gerenteeventointernacional', 'gerentersvp', 'coordenadorrsvp'].includes(perfil)) {
            actions.push({
                label: 'Agenda',
                icon: <FaCalendarAlt size={16} />,
                to: "/cadastroEventoAgenda/" + row.id
            });
        }

        // PAX Dia
        if (['admin', 'gerenteprojeto', 'gerentefinanceiro', 'gerenteevento', 'gerenteeventointernacional', 'gerentersvp', 'coordenadorrsvp'].includes(perfil)) {
            actions.push({
                label: 'PAX Dia',
                icon: <FaCalendarAlt size={16} />,
                to: "/cadastroEventoDiaQuantidade/" + row.id
            });
        }

        // Q&A
        if (['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'gerentersvp', 'coordenadorrsvp', 'qa', 'evento'].includes(perfil)) {
            actions.push({
                label: 'Q&A',
                icon: <FaQuestion size={16} />,
                action: () => {
                    setSelectedEvento(row);
                    setShowQAModal(true);
                }
            });
        }

        // Satisfação
        if (['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'evento', 'gerentersvp', 'coordenadorrsvp'].includes(perfil)) {
            actions.push({
                label: 'Satisfação',
                icon: <FaThumbsUp size={16} />,
                action: () => {
                    setSelectedEvento(row);
                    setShowSatisfacaoModal(true);
                }
            });
        }

        // Orçamentos
        if (['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento', 'gerenteevento', 'gerenteeventointernacional', 'evento', 'gerentersvp', 'coordenadorrsvp', 'backoffice'].includes(perfil)) {
            actions.push({
                label: 'Orçamentos',
                icon: <FaFileAlt size={16} />,
                to: "/orcamento?idEvento=" + row.id,
                badge: row.orcamentos ?? 0,
            });
        }

        // ========== RELATÓRIOS/VISUALIZAÇÃO ==========
        // One Page
        if (!['backoffice', 'backofficeinterno'].includes(perfil)) {
            actions.push({
                label: 'One Page',
                icon: <FaFileAlt size={16} />,
                to: "/onePageEvento/" + row.id
            });
        }

        // Histórico
        if (!['listarsvp', 'backoffice', 'backofficeinterno'].includes(perfil)) {
            actions.push({
                label: 'Histórico',
                icon: <FaList size={16} />,
                to: "/eventoHistorico/" + row.id
            });
        }

        // Resumo BackOffice
        if (['admin', 'gerenteprojeto', 'backoffice'].includes(perfil)) {
            actions.push({
                label: 'Resumo BackOffice',
                icon: <FaFileAlt size={16} />,
                to: "/eventoResumoBackOffice/" + row.id
            });
        }

        // Resumo de Book
        if (['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'evento', 'gerentersvp', 'coordenadorrsvp'].includes(perfil)) {
            actions.push({
                label: 'Resumo de Book',
                icon: <FaFileAlt size={16} />,
                to: "/eventoResumoBook/" + row.id
            });
        }

        // Resumo RSVP
        if (['admin', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'].includes(perfil)) {
            actions.push({
                label: 'Resumo RSVP',
                icon: <FaFileAlt size={16} />,
                to: "/eventoResumoRsvp/" + row.id
            });
        }

        // ========== OPERAÇÕES ESPECÍFICAS ==========
        // Freelancer (apenas para eventos nacionais)
        // Disponível para: admin, gerenteprojeto, gerenteevento, gerenteeventointernacional, evento, gerentersvp, coordenadorrsvp, backoffice
        if (perfisComAcessoFreelancer.includes(perfil) && (row.nacionalidade ?? 'nacional') === 'nacional')
            actions.push({
                label: 'Solicitar Freelancer',
                icon: <FaUserTie size={16} />,
                action: () => {
                    setSelectedEvento(row);
                    setShowFreelancerModal(true);
                }
            });


        if (perfisContratacaoFreelancerVisiveis.includes(perfil) && (row.nacionalidade ?? 'nacional') === 'nacional')
            actions.push({
                label: 'Contratação',
                icon: <FaUserTie size={16} />,
                action: () => {
                    setSelectedEvento(row);
                    setShowContratacaoFreelancerModal(true);
                }
            });

        // Emissão Aéreo (apenas para eventos internacionais)
        if (['rsvp', 'gerentersvp', 'coordenadorrsvp', 'admin'].includes(perfil)) {
            const isInternacional = (row.nacionalidade ?? 'nacional') === 'internacional';
            if (isInternacional) {
                actions.push({
                    label: 'Solicitar Emissão Aéreo',
                    icon: <FaPlane size={16} />,
                    action: () => {
                        setSelectedEvento(row);
                        setShowEmissaoAereoModal(true);
                    }
                });
            }
        }

        // Solicitar Malha Aérea — UM botão só, com o nome do trabalho de quem clica.
        //
        // Abre o PAINEL de solicitações do evento, não o editor de trechos: a solicitação
        // virou registro próprio, e é dela que os trechos e as malhas pendem.
        //
        // Para o Aéreo o mesmo destino se chama "Importação Malha Aérea": ele não pede
        // aéreo, responde ao pedido importando a cotação — e é por esse painel que chega
        // à malha. O rótulo é o texto exato do grupo "Equipe & Aéreo" do menu, que agrupa
        // por rótulo; outro texto faria o item cair fora da seção.
        //
        // O botão "Importação Malha Aérea" que existia ao lado SAIU: ele mandava o id do
        // EVENTO para uma tela endereçada pelo id da MALHA, e um evento tem N malhas — não
        // havia destino certo para ele apontar.
        // O RSVP (todo o time, menos a Lista Digital) abre o pedido; Eventos acompanha e aprova a
        // malha; o Aéreo responde. O Aéreo só vê a Importação quando o evento tem solicitação
        // enviada a ele, em qualquer situação (`aereoSolicitacoes`, contado no back).
        // O Gerente Aéreo tem o menu do Aéreo (`PERFIS_AEREO`).
        const ehAereo = PERFIS_AEREO.includes(perfil);
        const aereoSemSolicitacao = ehAereo && !(Number(row.aereoSolicitacoes) > 0);
        if (['admin', ...PERFIS_AEREO, ...PERFIS_RSVP, ...PERFIS_EVENTOS].includes(perfil) && !aereoSemSolicitacao) {
            actions.push({
                label: ehAereo ? 'Importação Malha Aérea' : 'Solicitar Malha Aérea',
                icon: ehAereo ? <FaUpload size={16} /> : <FaPlane size={16} />,
                to: "/cadastroEventoSolicitacoesAereo/" + row.id
            });
        }

        // Importação das Opções de Aéreo: o RSVP leva as opções das malhas aprovadas para as
        // opções que o participante escolhe. Mesmo grupo de perfis do back (EventoAereoPortacaoService).
        if (['admin', ...PERFIS_RSVP].includes(perfil)) {
            actions.push({
                label: 'Importação das Opções de Aéreo',
                icon: <FaExchangeAlt size={16} />,
                to: "/cadastroEventoPortacaoAereo/" + row.id
            });
        }
        // O Solicitar Emissão de Aéreo não entra neste menu: abre só pelo painel de participantes.

        // Emissão de Aéreo: só o Aéreo (e admin) abre — o RSVP acompanha a mesma planilha na tela
        // Solicitar Emissão de Aéreo, pelo painel de participantes. O Aéreo só vê o botão quando o
        // evento tem alguma requisição, em qualquer situação (`aereoEmissoes`).
        const aereoSemEmissao = ehAereo && !(Number(row.aereoEmissoes) > 0);
        if (['admin', ...PERFIS_AEREO].includes(perfil) && !aereoSemEmissao) {
            actions.push({
                label: 'Emissão de Aéreo',
                icon: <FaUpload size={16} />,
                to: "/cadastroEventoEmissaoAereo/" + row.id
            });
        }

        // Atendimento do Aéreo: quem atende o evento, no mesmo modal do cabeçalho
        // das telas do aéreo. Só para o Aéreo e o admin.
        if (['admin', ...PERFIS_AEREO].includes(perfil)) {
            actions.push({
                label: 'Atendimento',
                icon: <FaHeadset size={16} />,
                atendimento: true,
                action: () => {
                    setEventoAtendimento(String(row.id));
                    atendimento.abrir();
                },
            });
        }

        // Ordens de Serviço Hotel
        if (['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'evento', 'gerentersvp', 'coordenadorrsvp'].includes(perfil)) {
            actions.push({
                label: 'Ordens de Serviço Hotel',
                icon: <FaFileAlt size={16} />,
                action: () => {
                    // Salva dados essenciais do evento no localStorage
                    localStorage.setItem('eventoSelecionado', JSON.stringify({
                        id: row.id,
                        nome: row.nome,
                        data: row.data,
                        dataFim: row.dataFim
                    }));
                    window.location.href = "/cadastroEventoOrdemServico/" + row.id;
                }
            });
        }

        // ========== STATUS DO EVENTO ==========
        // Fechamento por departamento: só para quem é de um, e o back confere o cargo real. O modal mostra os
        // três departamentos e fecha ou desfaz o de quem está logado.
        if (departamentoUsuario && (row.situacao ?? '').toString().toLowerCase() !== 'cancelado') {
            actions.push({
                label: 'Fechamento',
                icon: <ImCancelCircle size={16} />,
                action: () => setFechamentoDe(row)
            });
        }

        // Reabrir evento — só faz sentido nos dois estados finais que a reabertura desfaz, e é o
        // que o backend aceita (`reabrirEvento` recusa o resto com 422). O gate antigo era
        // `row.situacao === 1`, idioma da tabela de PARCELAS (situação numérica, ver a coluna
        // "Aberto/Pago" mais abaixo): aqui `situacao` é string, então aquilo nunca era verdadeiro e
        // o botão aparecia em qualquer evento, só pelo perfil.
        if (['fechado', 'cancelado'].includes((row.situacao ?? '').toString().toLowerCase())
            && ['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro'].includes(perfil)) {
            actions.push({
                label: 'Reabrir',
                icon: <GiOpenChest size={16} />,
                action: () => {
                    Alert({
                        icon: "info",
                        denyButton: "Sair",
                        confirmButton: <><FaThumbsUp size={20} /> Reabrir</>,
                        title: "Reabrir Evento",
                        callBack: (result) => {
                            if (result.isConfirmed) {
                                api({
                                    method: 'put',
                                    action: '/evento/reabrir/' + row.id,
                                    token: token
                                })
                                    .then(function (response) {
                                        buscar();
                                    })
                                    .catch(function (error) {
                                        // O backend recusa a reabertura com 422 e a razão em
                                        // `data.error` (ex.: evento nem fechado nem cancelado).
                                        // Engolir o erro fazia o botão parecer sem efeito.
                                        const mensagem = error.response?.data?.error
                                            || 'Erro ao reabrir o evento';
                                        toast.error(mensagem);
                                    });
                            }
                        }
                    });
                }
            });
        }

        // Cancelar evento
        if (['admin', 'gerenteprojeto', 'gerentefinanceiro', 'backoffice'].includes(perfil)) {
            actions.push({
                label: 'Cancelar',
                icon: <ImCancelCircle size={16} />,
                action: () => {
                    Alert({
                        icon: "error",
                        confirmButton: "Sair",
                        denyButton: <><FaThumbsUp size={20} /> Cancelar</>,
                        html: `
                            <div class="form-group">
                                <label>Data de cancelamento:</label>
                                <input type="date" id="dataCancelamento" class="form-control" value="${dados.dataCancelamento ? dataMysql(dados.dataCancelamento) : dataMysql(new Date())}" />
                            </div>
                        `,
                        title: "Cancelar Evento",
                        callBack: (result) => {
                            if (result.isDenied) {
                                const dataCancelamento = document.getElementById('dataCancelamento')?.value;
                                api({
                                    method: 'put',
                                    action: '/evento/' + row.id,
                                    token: token,
                                    data: {
                                        ...{ situacao: "cancelado" },
                                        ...{ dataCancelamento: dataCancelamento || dataMysql(new Date()) }
                                    }
                                })
                                    .then(function (response) {
                                        buscar();
                                    })
                                    .catch(function (error) {
                                        // Mesmo motivo do Reabrir: engolir o erro fazia o botão
                                        // parecer sem efeito quando o backend recusava.
                                        const mensagem = error.response?.data?.error
                                            || 'Erro ao cancelar o evento';
                                        toast.error(mensagem);
                                    });
                            }
                        }
                    });
                }
            });
        }

        // Recusar Evento (apenas BackOffice)
        if (['admin', 'gerenteprojeto', 'backoffice'].includes(perfil)) {
            actions.push({
                label: 'Recusar Evento',
                icon: <FaBan size={16} />,
                action: () => {
                    setSelectedEvento(row);
                    setShowRecusarEventoModal(true);
                }
            });
        }

        // Arquivos de Pagamentos (apenas Diretor e BackOffice)
        if (['admin', 'gerenteprojeto', 'backoffice'].includes(perfil)) {
            actions.push({
                label: 'Arquivos de Pagamentos',
                icon: <FaFileAlt size={16} />,
                action: () => {
                    setSelectedEvento(row);
                    setShowParcelasModal(true);
                    buscarParcelasEvento(row.id);
                }
            });
        }

        // Perfil "aéreo": no menu do evento vê SÓ a entrada do fluxo de aéreo (as demais
        // telas são bloqueadas). Filtro no fim blinda contra os gates negativos (One Page,
        // Histórico) e qualquer item futuro adicionado ao menu. A Importação não entra
        // aqui: ela é aberta de dentro do painel de Malhas, pelo id da malha. Vale para o Gerente Aéreo.
        // O Atendimento também fica: é o modal do fluxo, sem rota.
        if (PERFIS_AEREO.includes(perfil)) {
            actions = actions.filter(a => a.atendimento || (a.to && (
                a.to.startsWith('/cadastroEventoSolicitacoesAereo') ||
                a.to.startsWith('/cadastroEventoSolicitacaoAereo') ||
                a.to.startsWith('/cadastroEventoEmissaoAereo')
            )));
        }

        // Tela restrita (RestrictedRoute): o item não aparece para quem não tem a permissão dela.
        actions = actions.filter(a => !a.to || !ehRestrita(a.to) || permissoes.temAcesso(a.to));

        if (actions.length === 0) {
            return null;
        }

        return (
            <button
                className="fin-pp__rowbtn"
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    setActionsModalData({ evento: row, actions: actions });
                    setShowActionsModal(true);
                }}
            >
                <FaEllipsisV size={14} />
            </button>
        );
    };

    return (
        <ErpTemplate sidebar={['listarsvp'].includes(perfil) ? false : true}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Eventos</h1>
                        <p className="fin-pp__subtitle">Painel de eventos · gestão e acompanhamento</p>
                    </div>
                    <div className="fin-pp__actions">
                        {[
                            { to: '/cadastroEvento', label: 'Novo Evento', icon: <FaPlus size={15} />, primary: true, roles: ['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'evento', 'gerentersvp', 'coordenadorrsvp'] },
                            { to: '/eventoResponsavelCliente', label: 'Responsáveis no Cliente', icon: <FaList size={15} />, roles: ['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'gerentersvp', 'coordenadorrsvp'] },
                            { to: '/local', label: 'Locais', icon: <FaList size={15} />, roles: ['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'gerentersvp', 'coordenadorrsvp', 'evento'] },
                            { to: '/eventoImportarKpi', label: 'Importar Planilha KPI', icon: <FaUpload size={15} />, roles: ['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'gerentersvp', 'coordenadorrsvp', 'evento'] },
                            { to: '/eventoImportarSanofi', label: 'Importar Planilha Sanofi', icon: <FaUpload size={15} />, roles: ['admin', 'diretor', 'gerenteprojeto'] },
                            { to: '/eventoImportarEventos', label: 'Importar Eventos do Excel', icon: <FaUpload size={15} />, roles: ['admin', 'diretor', 'gerenteprojeto'] },
                            { to: '/eventoCarta', label: 'Modelos de Cartas', icon: <GrMail size={15} />, roles: ['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'] },
                            { to: '/cartaFila', label: 'Fila de envio', icon: <RiMailSendLine size={15} />, roles: PERFIS_ENVIO_MASSA },
                            { to: '/eventoParticipanteSituacao', label: 'Status de Participantes', icon: <FaList size={15} />, roles: ['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'] },
                            { to: '/eventoRelatorio', label: 'Relatório de eventos', icon: <FaTable size={15} />, roles: ['admin', 'rsvp', 'gerentersvp', 'coordenadorrsvp', 'listarsvp', 'diretor'] },
                            { to: '/exportarEventoExecucao', label: 'Exportar Evento Execução', icon: <FaTable size={15} />, roles: ['admin', 'rsvp', 'gerentersvp', 'coordenadorrsvp', 'listarsvp'] },
                            { to: '/aereoFaturaCvc', label: 'Faturas CVC', icon: <FaFileInvoiceDollar size={15} />, roles: ['admin', ...PERFIS_AEREO] },
                        ].filter(a => a.roles.includes(perfil)).map(a => (
                            <Link key={a.to} to={a.to} className={'fin-pp__btn fin-pp__btn--pill' + (a.primary ? ' fin-pp__btn--primary' : ' fin-pp__btn--sm')}>
                                {a.icon} {a.label}
                            </Link>
                        ))}
                    </div>
                </div>
                {!['listarsvp'].includes(perfil) ?
                    <form className="fin-pp__card fin-pp__search" style={{ padding: '14px 16px' }} onSubmit={(e) => { buscar({ page: 1, resetPage: true }); e.preventDefault(); }}>
                        <div className="fin-pp__search-field">
                            <FaSearch className="fin-pp__search-ic" size={16} />
                            <input
                                autoFocus
                                type="text"
                                className="fin-pp__input"
                                placeholder="Buscar pelo nome do evento…"
                                value={filtro.nome ?? ""}
                                onChange={e => setFiltro({ ...filtro, ...{ "nome": e.target.value } })}
                            />
                        </div>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--tall">
                            <FaSearch size={14} /> Buscar
                        </button>
                        <button type="button" className="fin-pp__btn fin-pp__btn--tall" onClick={abrirFiltros}>
                            <FaFilter size={14} /> Mais filtros
                        </button>
                    </form> : null}
                <div
                    className={`modal fade ${mostrarFiltros ? 'show d-block' : ''} fin-pp fin-pp__modalbg`}
                    tabIndex="-1"
                    style={{ display: mostrarFiltros ? 'block' : 'none' }}
                    onClick={(e) => { if (e.target === e.currentTarget) setMostrarFiltros(false); }}
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaFilter size={17} /></span>
                                <h3 className="fin-pp__modal-title">Filtros avançados
                                    <span className="fin-pp__modal-sub">Refine a lista de eventos</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setMostrarFiltros(false)}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                {carregandoFiltros ? <div className="fin-pp__empty">Carregando filtros…</div> : null}
                                <div className="fin-pp__filters" style={{ alignItems: 'stretch' }}>
                                    <div className="fin-pp__field" style={{ flex: '1 1 100%' }}>
                                        <label className="fin-pp__label">Cliente</label>
                                        <ReactSelect
                                            id="cliente"
                                            defaultOptions={opcoesCliente}
                                            value={filtro.cliente ? { value: filtro.cliente, label: filtro.nomeCliente } : null}
                                            onChange={e => setFiltro({ ...filtro, ...{ "cliente": e?.value ?? null, "nomeCliente": e?.label ?? null } })}
                                            loadOptions={(input) => Promise.resolve(filtrarOpcoesLocais(opcoesCliente, input))}
                                        />
                                    </div>
                                    {!['rsvp', 'gerentersvp', 'coordenadorrsvp', 'listarsvp'].includes(perfil) ?
                                        <div className="fin-pp__field">
                                            <label className="fin-pp__label">Quarter</label>
                                            <Select
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        background: "#f7faff",
                                                    }),
                                                }}
                                                isMulti
                                                value={filtro.quarter}
                                                onChange={(e) => { setFiltro({ ...filtro, ...{ "quarter": e } }); }}
                                                options={[
                                                    { value: 'Q1', label: 'Q1' },
                                                    { value: 'Q2', label: 'Q2' },
                                                    { value: 'Q3', label: 'Q3' },
                                                    { value: 'Q4', label: 'Q4' },
                                                ]}
                                            />
                                        </div> : null
                                    }
                                    <div className="fin-pp__field">
                                        <label className="fin-pp__label">Responsável</label>
                                        <ReactSelect
                                            defaultOptions={opcoesResponsavelComItemFixo}
                                            value={valorResponsavelFiltro}
                                            onChange={e => setFiltro({ ...filtro, ...{ "qualquerResponsavel": e ? e.value : null, "nomeResponsavel": e?.label ?? null } })}
                                            loadOptions={(input) => Promise.resolve(filtrarOpcoesLocais(opcoesResponsavelComItemFixo, input))}
                                        />
                                    </div>
                                    <div className="fin-pp__field">
                                        <label className="fin-pp__label">
                                            Data Inicial
                                            {filtro.dataInicial && <span className="text-primary ms-1">●</span>}
                                        </label>
                                        <input
                                            type="date"
                                            className="fin-pp__input"
                                            value={filtro.dataInicial || ''}
                                            onChange={e => setFiltro({ ...filtro, ...{ "dataInicial": e.target.value } })}
                                        />
                                    </div>
                                    <div className="fin-pp__field">
                                        <label className="fin-pp__label">
                                            Data Final
                                            {filtro.dataFinal && <span className="text-primary ms-1">●</span>}
                                        </label>
                                        <input
                                            type="date"
                                            className="fin-pp__input"
                                            value={filtro.dataFinal || ''}
                                            min={filtro.dataInicial || undefined}
                                            onChange={e => setFiltro({ ...filtro, ...{ "dataFinal": e.target.value } })}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button
                                    type="button"
                                    className="fin-pp__btn"
                                    onClick={() => setFiltro((valorAtual) => ({
                                        ...valorAtual,
                                        cliente: null,
                                        nomeCliente: null,
                                        qualquerResponsavel: null,
                                        nomeResponsavel: null,
                                        quarter: null,
                                        dataInicial: '',
                                        dataFinal: '',
                                    }))}
                                >
                                    Limpar filtros
                                </button>
                                <button
                                    type="button"
                                    className="fin-pp__btn fin-pp__btn--primary"
                                    onClick={() => {
                                        setMostrarFiltros(false);
                                        buscar({ page: 1, resetPage: true });
                                    }}
                                >
                                    <FaSearch size={14} /> Aplicar filtros
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="section">
                    {/* Abas para filtrar eventos */}
                    <div className="fin-pp__tabs mb-3">
                        {[
                            { key: 'abertos', label: 'Eventos Abertos' },
                            { key: 'fechados', label: 'Fechados' },
                            { key: 'cancelados', label: 'Cancelados' },
                            { key: 'pendentes', label: 'Pendentes' },
                            ...(departamentoUsuario ? [{ key: 'fechadosDepartamento', label: DEPARTAMENTOS_FECHAMENTO[departamentoUsuario].aba }] : []),
                        ].map(t => {
                            const ativa = abaAtiva === t.key;
                            return (
                                <button key={t.key} type="button" onClick={() => setAbaAtiva(t.key)}
                                    className={'fin-pp__tab' + (ativa ? ' is-active' : '')}>
                                    {t.label}
                                    <span className="fin-pp__seg-count">{formatarBadgeTotal(totalResumoAba(t.key))}</span>
                                </button>
                            );
                        })}
                    </div>
                    <div className="fin-pp__cphead" style={{ marginTop: 4 }}>
                        <span className="fin-pp__cphead-ic"><FaCalendarAlt size={18} /></span>
                        <div style={{ minWidth: 0 }}>
                            <h2 className="fin-pp__cphead-title">Eventos</h2>
                            <p className="fin-pp__cphead-sub">{formatarBadgeTotal(totalResumoAba(abaAtiva))} eventos nesta visão</p>
                        </div>
                    </div>
                    <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                                <div className="fin-pp__tblwrap">
                                    {(() => {
                                        const ehListaRsvp = ['listarsvp'].includes(perfil);
                                        const onSort = (field) => {
                                            const dir = (ordenacao && ordenacao[field] === 'asc') ? 'desc' : 'asc';
                                            ordenarTabela({ sortField: field }, dir);
                                        };
                                        const seta = (field) => (ordenacao && ordenacao[field]) ? (ordenacao[field] === 'asc' ? ' ▲' : ' ▼') : '';
                                        const Th = (label, field, extra) => (
                                            <th className={field ? 'is-sortable' : ''} onClick={field ? () => onSort(field) : undefined} style={extra}>{label}{field ? seta(field) : ''}</th>
                                        );
                                        const fmtData = (row) => {
                                            var dataCompetencia = row.dataCompetencia ? " " + moment(row.dataCompetencia).format("MM/YYYY") : "";
                                            var dataInicio = row.data ? " " + moment(row.data).format("DD/MM/YYYY") : "";
                                            dataInicio = row.replanejadoInicio ? " " + moment(row.replanejadoInicio).format("DD/MM/YYYY") : dataInicio;
                                            var dataFim = row.dataFim ? " " + moment(row.dataFim).format("DD/MM/YYYY") : "";
                                            dataFim = row.replanejadoFim ? " " + moment(row.replanejadoFim).format("DD/MM/YYYY") : dataFim;
                                            var dataCancelamento = row.dataCancelamento ? " Cancelado: " + moment(row.dataCancelamento).format("DD/MM/YYYY") : "";
                                            var dataFechamento = row.dataFechamento ? " Fechado: " + moment(row.dataFechamento).format("DD/MM/YYYY") : "";
                                            return (dataInicio === dataFim)
                                                ? (dataCompetencia + dataInicio + dataFechamento + dataCancelamento)
                                                : (dataCompetencia + dataInicio + dataFim + dataFechamento + dataCancelamento);
                                        };
                                        const clienteTxt = (row) => row.cliente
                                            ? (row.cliente.enderecomunicipio
                                                ? (row.cliente.codigo + ' - ' + row.cliente.nome + ' - ' + row.cliente.enderecomunicipio.nome + ' - ' + row.cliente.enderecomunicipio.uf)
                                                : (row.cliente.codigo + ' - ' + row.cliente.nome))
                                            : '';
                                        return (
                                            <table className="fin-pp__tbl" style={{ minWidth: ehListaRsvp ? 1000 : 1500, tableLayout: 'auto' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: 64 }}>Ações</th>
                                                        {!ehListaRsvp && Th('Código', 'codigo', { width: 90, textAlign: 'right' })}
                                                        {!ehListaRsvp && Th('Situação', 'situacao', { width: 120 })}
                                                        {!ehListaRsvp && Th('Identificação', 'identificacao', { width: 130, textAlign: 'right' })}
                                                        {ehListaRsvp && <th style={{ width: 160 }}></th>}
                                                        {Th('Nome do evento', 'nome')}
                                                        {!ehListaRsvp && Th('Cliente', 'cliente', { width: 220 })}
                                                        {!ehListaRsvp && Th('Quarter', 'quarter', { width: 80 })}
                                                        {!ehListaRsvp && Th('Complexidade', 'complexidade', { width: 110 })}
                                                        {!ehListaRsvp && Th('Data', 'data', { width: 130 })}
                                                        {!ehListaRsvp && Th('Responsável', 'responsavel', { width: 140 })}
                                                        {!ehListaRsvp && Th('Resp. RSVP', 'coordenadorrsvp', { width: 140 })}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filtro.buscando ? (
                                                        <tr><td colSpan={ehListaRsvp ? 3 : 11} className="fin-pp__empty" style={{ padding: 0 }}><TabelaLoading /></td></tr>
                                                    ) : dadosParaExibir.length === 0 ? (
                                                        <tr><td colSpan={ehListaRsvp ? 3 : 11} className="fin-pp__empty" style={{ padding: 0 }}><TabelaVazia /></td></tr>
                                                    ) : dadosParaExibir.map((row) => (
                                                        <tr key={row.id}>
                                                            <td>{renderActionDropdown(row)}</td>
                                                            {!ehListaRsvp && <td className="fin-pp__cell-num" style={{ fontWeight: 400 }}>{row.codigo ?? ''}</td>}
                                                            {!ehListaRsvp && (
                                                                <td>{row.situacao
                                                                    ? (() => { const s = row.situacao.toString().toLowerCase(); const tone = s === 'ativo' ? 'is-ok' : s === 'cancelado' ? 'is-danger' : s === 'pendente' ? 'is-warn' : s === 'fechado' ? 'is-info' : 'is-muted'; return <span className={'fin-pp__pill ' + tone}>{row.situacao.charAt(0).toUpperCase() + row.situacao.slice(1)}</span>; })()
                                                                    : <span style={{ color: 'var(--fin-mt)' }}>—</span>}</td>
                                                            )}
                                                            {!ehListaRsvp && <td className="fin-pp__cell-muted" style={{ textAlign: 'right' }}>{row.identificacao ?? ''}</td>}
                                                            {ehListaRsvp && <td><Link to={"/eventoParticipante/" + row.id} className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--sm" style={{ textDecoration: 'none' }}><FaUsers size={16} style={{ marginRight: 6 }} /> Participantes</Link></td>}
                                                            <td className="fin-pp__cell-strong">
                                                                {row.nome}
                                                                {perfil === 'backofficeinterno' && (row.freelancers ?? 0) > 0 && (
                                                                    <span className="fin-pp__minitag is-warn" style={{ marginLeft: 8 }}><FaUserTie size={11} /> Freelancer</span>
                                                                )}
                                                                {/* Saber quais eventos já têm orçamento exigia abrir o menu de
                                                                    ações (o contador só existia lá dentro). Mini-tag ao lado do
                                                                    nome — não cria coluna nova: a tabela já tem 10. */}
                                                                {!ehListaRsvp && (row.orcamentos ?? 0) > 0 && (
                                                                    <span className="fin-pp__minitag is-info" style={{ marginLeft: 8 }}
                                                                        title={`${row.orcamentos} orçamento${row.orcamentos > 1 ? 's' : ''} neste evento`}>
                                                                        <FaFileAlt size={11} /> {row.orcamentos}
                                                                    </span>
                                                                )}
                                                            </td>
                                                            {!ehListaRsvp && <td className="fin-pp__cell-muted">{clienteTxt(row)}</td>}
                                                            {!ehListaRsvp && <td className="fin-pp__cell-muted">{row.quarter || ''}</td>}
                                                            {!ehListaRsvp && <td className="fin-pp__cell-muted">{row.complexidade || ''}</td>}
                                                            {!ehListaRsvp && <td className="fin-pp__cell-muted">{fmtData(row)}</td>}
                                                            {!ehListaRsvp && (
                                                                <td className="fin-pp__cell-muted">{row.responsavel && Array.isArray(row.responsavel)
                                                                    ? row.responsavel.map((r, i) => <div key={i}>{r.nome}</div>)
                                                                    : (row.responsavel ? row.responsavel.nome : '')}</td>
                                                            )}
                                                            {!ehListaRsvp && <td className="fin-pp__cell-muted">{row.coordenadorrsvp?.nome ? <span title={row.coordenadorrsvp.nome}>{row.coordenadorrsvp.nome}</span> : <span style={{ color: 'var(--fin-mt)' }}>—</span>}</td>}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        );
                                    })()}
                                </div>
                                {pagination.total > 0 && (() => {
                                    const totalPaginas = Math.max(1, Math.ceil(pagination.total / pagination.pageSize));
                                    const p = pagination.page;
                                    return (
                                        <div className="fin-pp__pagination">
                                            <div className="fin-pp__pagination-info">
                                                {((p - 1) * pagination.pageSize) + 1}–{Math.min(p * pagination.pageSize, pagination.total)} de {pagination.total}
                                            </div>
                                            <div className="fin-pp__pagination-ctrls">
                                                <select className="fin-pp__select" style={{ height: 34 }} value={pagination.pageSize} onChange={(e) => buscar({ page: 1, pageSize: Number(e.target.value), resetPage: true })}>
                                                    {[10, 20, 50, 100].map(n => <option key={n} value={n}>{n} / pág.</option>)}
                                                </select>
                                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={p <= 1} onClick={() => buscar({ page: p - 1 })}>Anterior</button>
                                                <span className="fin-pp__pagination-info">{p} / {totalPaginas}</span>
                                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={p >= totalPaginas} onClick={() => buscar({ page: p + 1 })}>Próxima</button>
                                            </div>
                                        </div>
                                    );
                                })()}

                            </div>
                </section>

                {/* Modal Q&A */}
                {showQAModal && (
                    <>
                        <div className="modal-backdrop fade show fin-pp__modalbg" style={{ zIndex: 1040 }}></div>
                        <div className="modal fade show d-block fin-pp" style={{ zIndex: 1050 }} tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                                <div className="modal-content fin-pp__modal">
                                    <div className="fin-pp__modal-head">
                                        <span className="fin-pp__modal-head-ic"><FaQuestion size={17} /></span>
                                        <h3 className="fin-pp__modal-title">Q&amp;A
                                            <span className="fin-pp__modal-sub">{selectedEvento?.nome}</span>
                                        </h3>
                                        <button type="button" className="fin-pp__modal-close" onClick={() => setShowQAModal(false)}><FaTimes size={16} /></button>
                                    </div>
                                    <div className="modal-body">
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                            <form method="post" action={process.env.REACT_APP_API_URL + "/evento/exportarPerguntas"} target="_blank">
                                                {/* exportarPerguntas faz json_decode($request->data): tudo num único campo "data" */}
                                                <input type="hidden" name="data" value={JSON.stringify({ token: localStorage.getItem('token'), idEvento: selectedEvento?.id })} />
                                                <button type="submit" className="fin-pp__btn fin-pp__btn--primary" style={{ width: '100%' }}>
                                                    <FaTable size={16} style={{ marginRight: 8 }} /> Relatório (PDF)
                                                </button>
                                            </form>
                                            <Link to={"/eventoPerguntaQrCode/" + selectedEvento?.id} className="fin-pp__btn fin-pp__btn--primary" style={{ width: '100%', textDecoration: 'none' }}>
                                                <FaQrcode size={16} style={{ marginRight: 8 }} /> QrCodes
                                            </Link>
                                            <Link to={"/eventoPalestrante/" + selectedEvento?.id} className="fin-pp__btn fin-pp__btn--primary" style={{ width: '100%', textDecoration: 'none' }}>
                                                <FaUsers size={16} style={{ marginRight: 8 }} /> Palestrantes
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {/* Modal Ordens de Serviço Hotel */}
                {showOrdemServicoModal && (
                    <>
                        <div className="modal-backdrop fade show fin-pp__modalbg" style={{ zIndex: 1040 }}></div>
                        <div className="modal fade show d-block fin-pp" style={{ zIndex: 1050 }} tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                                <div className="modal-content fin-pp__modal">
                                    <div className="fin-pp__modal-head">
                                        <span className="fin-pp__modal-head-ic"><FaFileAlt size={17} /></span>
                                        <h3 className="fin-pp__modal-title">Ordens de Serviço Hotel
                                            <span className="fin-pp__modal-sub">{selectedEvento?.nome}</span>
                                        </h3>
                                        <button type="button" className="fin-pp__modal-close" onClick={() => setShowOrdemServicoModal(false)}><FaTimes size={16} /></button>
                                    </div>
                                    <div className="modal-body">
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                            <Link to={"/cadastroEventoOrdemServicoResumo/" + selectedEvento?.id} className="fin-pp__btn fin-pp__btn--primary" style={{ width: '100%', textDecoration: 'none' }}>
                                                <FaList size={16} style={{ marginRight: 8 }} /> Resumo
                                            </Link>
                                            <Link to={"/cadastroEventoOrdemServico/" + selectedEvento?.id} className="fin-pp__btn fin-pp__btn--primary" style={{ width: '100%', textDecoration: 'none' }}>
                                                <FaFileAlt size={16} style={{ marginRight: 8 }} /> Ordem de Serviço
                                            </Link>
                                            <form method="post" action={process.env.REACT_APP_API_URL + "/evento/exportarOrdemServico"} target="_blank">
                                                <input type="hidden" name="token" value={localStorage.getItem('token')} />
                                                <input type="hidden" name="idEvento" value={selectedEvento?.id} />
                                                <button type="submit" className="fin-pp__btn fin-pp__btn--primary" style={{ width: '100%' }}>
                                                    <FaTable size={16} style={{ marginRight: 8 }} /> Relatório
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {/* Modal Freelancer */}
                {showFreelancerModal && (
                    <>
                        <div className="modal-backdrop fade show fin-pp__modalbg" style={{ zIndex: 1040 }}></div>
                        <div className="modal fade show d-block fin-pp" style={{ zIndex: 1050 }} tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                                <div className="modal-content fin-pp__modal">
                                    <div className="fin-pp__modal-head">
                                        <span className="fin-pp__modal-head-ic"><FaUserTie size={17} /></span>
                                        <h3 className="fin-pp__modal-title">Solicitar Freelancer
                                            <span className="fin-pp__modal-sub">{selectedEvento?.nome}</span>
                                        </h3>
                                        <button type="button" className="fin-pp__modal-close" onClick={() => setShowFreelancerModal(false)}><FaTimes size={16} /></button>
                                    </div>
                                    <div className="modal-body">
                                        <FreelancerForm
                                            eventoId={selectedEvento?.id}
                                            onClose={() => setShowFreelancerModal(false)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {/* Modal Contratação de Freelancers */}
                {showContratacaoFreelancerModal && (
                    <>
                        <div className="modal-backdrop fade show fin-pp__modalbg" style={{ zIndex: 1040 }} onClick={() => setShowContratacaoFreelancerModal(false)}></div>
                        <div className="modal fade show d-block fin-pp" style={{ zIndex: 1050 }} tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
                                <div className="modal-content fin-pp__modal">
                                    <div className="fin-pp__modal-head">
                                        <span className="fin-pp__modal-head-ic"><FaUsers size={17} /></span>
                                        <h3 className="fin-pp__modal-title">Contratação de Freelancers
                                            <span className="fin-pp__modal-sub">{selectedEvento?.nome}</span>
                                        </h3>
                                        <button type="button" className="fin-pp__modal-close" onClick={() => setShowContratacaoFreelancerModal(false)}><FaTimes size={16} /></button>
                                    </div>
                                    <div className="modal-body">
                                        <ContratacaoForm
                                            eventoId={selectedEvento?.id}
                                            canEdit={perfisContratacaoFreelancerEditaveis.includes(perfil)}
                                            onClose={() => setShowContratacaoFreelancerModal(false)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {/* Modal Emissão Aéreo */}
                {showEmissaoAereoModal && (
                    <>
                        <div className="modal-backdrop fade show fin-pp__modalbg" style={{ zIndex: 1040 }}></div>
                        <div className="modal fade show d-block fin-pp" style={{ zIndex: 1050 }} tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                                <div className="modal-content fin-pp__modal">
                                    <div className="fin-pp__modal-head">
                                        <span className="fin-pp__modal-head-ic"><FaPlane size={17} /></span>
                                        <h3 className="fin-pp__modal-title">Solicitação para Emissão de Aéreo
                                            <span className="fin-pp__modal-sub">{selectedEvento?.nome}</span>
                                        </h3>
                                        <button type="button" className="fin-pp__modal-close" onClick={() => setShowEmissaoAereoModal(false)}><FaTimes size={16} /></button>
                                    </div>
                                    <div className="modal-body">
                                        <EmissaoAereoForm
                                            eventoId={selectedEvento?.id}
                                            onClose={() => setShowEmissaoAereoModal(false)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {/* Modal Satisfação */}
                {showSatisfacaoModal && (
                    <>
                        <div className="modal-backdrop fade show fin-pp__modalbg" style={{ zIndex: 1040 }}></div>
                        <div className="modal fade show d-block fin-pp" style={{ zIndex: 1050 }} tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                                <div className="modal-content fin-pp__modal">
                                    <div className="fin-pp__modal-head">
                                        <span className="fin-pp__modal-head-ic"><FaQuestion size={17} /></span>
                                        <h3 className="fin-pp__modal-title">Satisfação
                                            <span className="fin-pp__modal-sub">{selectedEvento?.nome}</span>
                                        </h3>
                                        <button type="button" className="fin-pp__modal-close" onClick={() => setShowSatisfacaoModal(false)}><FaTimes size={16} /></button>
                                    </div>
                                    <div className="modal-body">
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                            <Link to={"/cadastroEventoSatisfacaoPergunta/" + selectedEvento?.id} className="fin-pp__btn fin-pp__btn--primary" style={{ width: '100%', textDecoration: 'none' }}>
                                                <FaQuestion size={16} style={{ marginRight: 8 }} /> Perguntas
                                            </Link>
                                            <Link to={"/eventoSatisfacaoResultado/" + selectedEvento?.id} className="fin-pp__btn fin-pp__btn--primary" style={{ width: '100%', textDecoration: 'none' }}>
                                                <FaTable size={16} style={{ marginRight: 8 }} /> Resultados
                                            </Link>
                                            <form method="post" action={process.env.REACT_APP_API_URL + "/evento/exportarSatisfacaoPerguntas"} target="_blank">
                                                <input type="hidden" name="token" value={localStorage.getItem('token')} />
                                                <input type="hidden" name="idEvento" value={selectedEvento?.id} />
                                                <button type="submit" className="fin-pp__btn fin-pp__btn--primary" style={{ width: '100%' }}>
                                                    <FaTable size={16} style={{ marginRight: 8 }} /> Relatório
                                                </button>
                                            </form>
                                        </div>

                                        {/* Card: dados da pesquisa */}
                                        {carregandoResumoSatisfacao && (
                                            <p style={{ color: 'var(--fin-mt)', fontSize: 13, margin: '12px 0' }}>Carregando...</p>
                                        )}
                                        {!carregandoResumoSatisfacao && resumoSatisfacao != null && (
                                            <div style={{ margin: '12px 0', padding: 12, borderRadius: 8, border: '1px solid var(--fin-brd)', background: '#fff' }}>
                                                <div style={{ fontSize: 13, color: 'var(--fin-mt)', marginBottom: 8 }}>Pesquisa de satisfação</div>
                                                {resumoSatisfacao.dataEnvioEmailPesquisaSatisfacao ? (
                                                    <div style={{ marginBottom: 4 }}>
                                                        E-mail enviado para todos em <strong>{moment(resumoSatisfacao.dataEnvioEmailPesquisaSatisfacao).format('DD/MM/YYYY HH:mm')}</strong>
                                                        {resumoSatisfacao.quantidadeEmailsEnviadosPesquisa != null && (
                                                            <span> ({resumoSatisfacao.quantidadeEmailsEnviadosPesquisa} participante(s))</span>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div style={{ marginBottom: 4 }}>Ainda não foi enviado e-mail em massa para os participantes.</div>
                                                )}
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 8, fontSize: 13 }}>
                                                    <span><strong>{resumoSatisfacao.totalResponderam ?? 0}</strong> já responderam</span>
                                                    <span><strong>{resumoSatisfacao.quantidadeEmailsEnviadosPesquisa ?? 0}</strong> e-mails enviados</span>
                                                    <span style={{ color: 'var(--fin-mt)' }}><strong>{resumoSatisfacao.totalPendentes ?? 0}</strong> ainda não responderam</span>
                                                </div>
                                            </div>
                                        )}

                                        {/* Copiar link e Enviar para todos */}
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                            <button
                                                type="button"
                                                className="fin-pp__btn fin-pp__btn--primary"
                                                onClick={() => {
                                                    const link = `${URL_PESQUISA_CLIENTE}/perguntassatisfacao/${selectedEvento?.id}`;
                                                    navigator.clipboard.writeText(link).then(() => {
                                                        toast.success('Link copiado!');
                                                    }).catch(() => toast.error('Não foi possível copiar o link.'));
                                                }}
                                            >
                                                <FaLink size={16} style={{ marginRight: 8 }} /> Copiar link da pesquisa
                                            </button>
                                            <button
                                                type="button"
                                                className="fin-pp__btn fin-pp__btn--primary"
                                                disabled={enviandoEmailSatisfacao}
                                                onClick={() => {
                                                    Alert({
                                                        title: 'Enviar e-mail da pesquisa para todos os participantes?',
                                                        html: 'Será enviado um e-mail para cada participante do evento com o link personalizado da pesquisa.',
                                                        confirmButton: 'Enviar',
                                                        denyButton: 'Cancelar',
                                                        callBack: (result) => {
                                                            if (!result.isConfirmed) return;
                                                            setEnviandoEmailSatisfacao(true);
                                                            api({
                                                                method: 'post',
                                                                action: `/eventoSatisfacaoPergunta/enviarEmailPesquisa/${selectedEvento?.id}`,
                                                                token: token,
                                                            })
                                                                .then((response) => {
                                                                    const data = response.data?.data ?? response.data;
                                                                    if (data.quantidadeSucesso > 0) {
                                                                        toast.success(data.quantidadeSucesso + ' e-mail(s) enviado(s) com sucesso.');
                                                                        api({ method: 'get', action: '/eventoSatisfacaoPergunta/resumoSatisfacao/' + selectedEvento?.id, token: token })
                                                                            .then(r => { const d = r.data?.data ?? r.data; if (d) setResumoSatisfacao(d); })
                                                                            .catch(() => { });
                                                                    }
                                                                    (data.erros || []).forEach((erro) => toast.error(erro.mensagem));
                                                                })
                                                                .catch((error) => {
                                                                    toast.error('Erro: ' + (error.response?.data?.error ?? 'ao enviar e-mails'));
                                                                })
                                                                .finally(() => setEnviandoEmailSatisfacao(false));
                                                        }
                                                    });
                                                }}
                                            >
                                                <RiMailSendLine size={20} style={{ marginRight: 8 }} /> {enviandoEmailSatisfacao ? 'Enviando...' : 'Enviar e-mail para todos'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {/* Modal Recusar Evento */}
                {fechamentoDe && (
                    <FechamentoEventoModal evento={fechamentoDe} departamento={departamentoUsuario}
                        onFechar={() => setFechamentoDe(null)}
                        onAplicado={() => { setFechamentoDe(null); buscar(); }} />
                )}

                {showRecusarEventoModal && (
                    <>
                        <div className="modal-backdrop fade show fin-pp__modalbg" style={{ zIndex: 1040 }}></div>
                        <div className="modal fade show d-block fin-pp" style={{ zIndex: 1050 }} tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                                <div className="modal-content fin-pp__modal">
                                    <div className="fin-pp__modal-head">
                                        <span className="fin-pp__modal-head-ic is-danger"><FaBan size={17} /></span>
                                        <h3 className="fin-pp__modal-title">Recusar Evento
                                            <span className="fin-pp__modal-sub">{selectedEvento?.nome}</span>
                                        </h3>
                                        <button type="button" className="fin-pp__modal-close" onClick={() => setShowRecusarEventoModal(false)}><FaTimes size={16} /></button>
                                    </div>
                                    <div className="modal-body">
                                        <RecusarEvento
                                            eventoId={selectedEvento?.id}
                                            eventoNome={selectedEvento?.nome}
                                            onClose={() => setShowRecusarEventoModal(false)}
                                            onSuccess={() => {
                                                buscar(); // Atualiza a lista de eventos
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* Modal Arquivos de Pagamentos */}
                {showParcelasModal && (
                    <>
                        <div className="modal-backdrop fade show fin-pp__modalbg" style={{ zIndex: 1040 }} onClick={() => setShowParcelasModal(false)}></div>
                        <div className="modal fade show d-block fin-pp" style={{ zIndex: 1050 }} tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
                                <div className="modal-content fin-pp__modal">
                                    <div className="fin-pp__modal-head">
                                        <span className="fin-pp__modal-head-ic"><FaDownload size={17} /></span>
                                        <h3 className="fin-pp__modal-title">Arquivos de Pagamentos
                                            <span className="fin-pp__modal-sub">{selectedEvento?.nome}</span>
                                        </h3>
                                        <button type="button" className="fin-pp__modal-close" onClick={() => setShowParcelasModal(false)}><FaTimes size={16} /></button>
                                    </div>
                                    <div className="modal-body">
                                        {parcelas.filter(p => p.arquivonotafiscal?.id).length > 0 ? (
                                            <div style={{ marginBottom: 12 }}>
                                                <form method="get" action={process.env.REACT_APP_API_URL + "/evento/notasFiscaisZip/" + selectedEvento?.id} target="_blank">
                                                    <input type="hidden" name="token" value={localStorage.getItem('token')} />
                                                    <button type="submit" className="fin-pp__btn fin-pp__btn--primary">
                                                        <FaDownload size={16} style={{ marginRight: 8 }} /> Baixar Todas as Notas Fiscais (ZIP)
                                                    </button>
                                                </form>
                                                <span style={{ color: 'var(--fin-mt)', fontSize: 13, marginLeft: 8 }}>
                                                    ({parcelas.filter(p => p.arquivonotafiscal?.id).length} nota(s) fiscal(is) disponível(eis))
                                                </span>
                                            </div>
                                        ) : (
                                            <p style={{ color: 'var(--fin-mt)', marginBottom: 12 }}>Nenhuma nota fiscal disponível para download</p>
                                        )}
                                        {carregandoParcelas ? (
                                            <p style={{ color: 'var(--fin-mt)', textAlign: 'center' }}>Carregando...</p>
                                        ) : (
                                            <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                                                <div className="fin-pp__tblwrap">
                                                    <table className="fin-pp__tbl" style={{ minWidth: 600, tableLayout: 'auto' }}>
                                                        <thead><tr>
                                                            <th>Título</th>
                                                            <th>Participante</th>
                                                            <th>Descrição</th>
                                                            <th>Vencimento</th>
                                                            <th style={{ textAlign: 'right' }}>Valor</th>
                                                            <th>Situação</th>
                                                            <th style={{ textAlign: 'center' }}>Nota Fiscal</th>
                                                        </tr></thead>
                                                        <tbody>
                                                            {parcelas.length === 0
                                                                ? <tr><td colSpan={7} className="fin-pp__empty">Nenhuma parcela encontrada para este evento</td></tr>
                                                                : parcelas.map((row, i) => (
                                                                    <tr key={i}>
                                                                        <td className="fin-pp__cell-muted">{row.titulo?.numero || '-'}</td>
                                                                        <td className="fin-pp__cell-muted">{row.participante?.nome || '-'}</td>
                                                                        <td className="fin-pp__cell-muted">{row.descricao || '-'}</td>
                                                                        <td className="fin-pp__cell-muted">{row.vencimento ? moment(row.vencimento).format('DD/MM/YYYY') : '-'}</td>
                                                                        <td className="fin-pp__cell-num">{row.valor ? moeda(row.valor) : '-'}</td>
                                                                        <td className="fin-pp__cell-muted">{row.situacao === 1 ? 'Aberto' : row.situacao === 2 ? 'Pago' : '-'}</td>
                                                                        <td style={{ textAlign: 'center' }}>
                                                                            {row.arquivonotafiscal?.id ? (
                                                                                <form method="get" action={process.env.REACT_APP_API_URL + "/financeiroParcelaArquivo/" + row.id} target="_blank">
                                                                                    <input type="hidden" name="token" value={token} />
                                                                                    <input type="hidden" name="tipoArquivo" value="notafiscal" />
                                                                                    <button type="submit" className="fin-pp__btn fin-pp__btn--sm" title="Baixar Nota Fiscal">
                                                                                        <FaFileAlt size={14} />
                                                                                    </button>
                                                                                </form>
                                                                            ) : (
                                                                                <span style={{ color: 'var(--fin-mt)' }}>-</span>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="fin-pp__modal-foot">
                                        <button type="button" className="fin-pp__btn" onClick={() => setShowParcelasModal(false)}>Fechar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* Drawer de Ações do evento */}
                {showActionsModal && (
                    <div className="fin-pp fin-pp__drawer-backdrop" onClick={() => setShowActionsModal(false)}>
                        <div className="fin-pp__drawer" onClick={(e) => e.stopPropagation()}>
                            <div className="fin-pp__drawer-head">
                                <span className="fin-pp__drawer-head-ic"><FaEllipsisV size={16} /></span>
                                <div style={{ minWidth: 0, flex: 1 }}>
                                    <h3 className="fin-pp__drawer-title">Ações do evento</h3>
                                    <p className="fin-pp__drawer-sub">{actionsModalData.evento?.nome}</p>
                                </div>
                                <button type="button" className="fin-pp__drawer-close" onClick={() => setShowActionsModal(false)}><FaTimes size={16} /></button>
                            </div>
                            <div className="fin-pp__drawer-body">
                                {(() => {
                                    const grupos = [
                                        { titulo: 'Cadastro & Dados', labels: ['Alterar', 'Dados RSVP', 'Dados Iniciais RSVP'] },
                                        { titulo: 'Participantes', labels: ['Participantes', 'Importar Participantes'] },
                                        { titulo: 'Operação', labels: ['Checklist', 'Agenda', 'PAX Dia', 'Ordens de Serviço Hotel'] },
                                        { titulo: 'RSVP & Pesquisa', labels: ['Q&A', 'Satisfação'] },
                                        { titulo: 'Equipe & Aéreo', labels: ['Solicitar Freelancer', 'Contratação', 'Solicitar Emissão Aéreo', 'Solicitar Malha Aérea', 'Importação Malha Aérea', 'Importação das Opções de Aéreo', 'Emissão de Aéreo', 'Atendimento'] },
                                        { titulo: 'Financeiro', labels: ['Orçamentos', 'Arquivos de Pagamentos'] },
                                        { titulo: 'Resumos & Relatórios', labels: ['One Page', 'Histórico', 'Resumo BackOffice', 'Resumo de Book', 'Resumo RSVP'] },
                                        { titulo: 'Status do evento', labels: ['Fechamento', 'Reabrir', 'Cancelar', 'Recusar Evento'] },
                                    ];
                                    const renderItem = (action, key) => {
                                        const inner = (
                                            <>
                                                <span className="fin-pp__drawer-item-ic">{action.icon}</span>
                                                <span className="fin-pp__drawer-item-label">{action.label}</span>
                                                {action.badge !== undefined && (
                                                    <span className="fin-pp__drawer-item-badge">{formatarBadgeTotal(action.badge)}</span>
                                                )}
                                            </>
                                        );
                                        if (action.to) {
                                            return <Link key={key} className="fin-pp__drawer-item" to={action.to} onClick={() => setShowActionsModal(false)}>{inner}</Link>;
                                        }
                                        return <button key={key} type="button" className="fin-pp__drawer-item" onClick={(e) => { e.stopPropagation(); action.action(); setShowActionsModal(false); }}>{inner}</button>;
                                    };
                                    const usados = new Set();
                                    const secoes = grupos.map(g => {
                                        const itens = actionsModalData.actions.filter(a => g.labels.includes(a.label));
                                        itens.forEach(a => usados.add(a.label));
                                        return { titulo: g.titulo, itens };
                                    }).filter(s => s.itens.length > 0);
                                    const outras = actionsModalData.actions.filter(a => !usados.has(a.label));
                                    if (outras.length) secoes.push({ titulo: 'Outras ações', itens: outras });
                                    return secoes.map((s, si) => (
                                        <div key={si}>
                                            <div className="fin-pp__drawer-section">{s.titulo}</div>
                                            {s.itens.map((a, i) => renderItem(a, si + '-' + i))}
                                        </div>
                                    ));
                                })()}
                            </div>
                        </div>
                    </div>
                )}

                {atendimento.modal}
            </div>
        </ErpTemplate>
    );
}
